module.exports = __webpack_public_path__ + "static/media/per.59cba4be.svg";